module.exports = __webpack_public_path__ + "img/kosmos-sign.9a449d7c.jpg";